if (!customElements.get('rotating-header-unique')) {
  class RotatingHeader extends HTMLElement {
    constructor() {
      super();
      this.wordsContainer = this.querySelector('.ai-rotating-header-words-');
      this.words = this.querySelectorAll('.ai-rotating-header-word-');
      this.interval = parseInt(this.wordsContainer?.dataset.interval, 10) * 1000;
      this.transitionSpeed = parseInt(this.wordsContainer?.dataset.transitionSpeed, 10) || 600;
      this.currentIndex = 0;
      this.wordCount = this.words.length;
      this.rotationTimer = null;
      this.observer = null;
    }

    connectedCallback() {
      if (this.wordCount <= 1 || !this.wordsContainer) return;

      if (!this.words[0]?.classList.contains('active')) {
        this.words[0].classList.add('active');
      }

      const initWidth = () => {
        this.setWordsContainerWidth();
        this.startRotation();
      };
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(initWidth);
      } else {
        initWidth();
      }

      this.observer = new IntersectionObserver(
        (entries) => {
          const visible = entries.some((entry) => entry.isIntersecting);
          if (visible) {
            this.startRotation();
          } else {
            this.stopRotation();
          }
        },
        { root: null, threshold: 0.1 },
      );
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.stopRotation();
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
    }

    startRotation() {
      if (this.rotationTimer || this.wordCount <= 1) return;
      this.rotationTimer = setInterval(() => {
        this.rotateWords();
      }, this.interval);
    }

    stopRotation() {
      if (!this.rotationTimer) return;
      clearInterval(this.rotationTimer);
      this.rotationTimer = null;
    }

    setWordsContainerWidth() {
      let maxWidth = 0;
      this.words.forEach((word) => {
        const originalStyle = word.getAttribute('style');
        word.style.position = 'absolute';
        word.style.visibility = 'hidden';
        word.style.display = 'inline-block';
        word.style.opacity = '0';
        word.style.whiteSpace = 'nowrap';

        maxWidth = Math.max(maxWidth, word.offsetWidth);

        if (originalStyle !== null) {
          word.setAttribute('style', originalStyle);
        } else {
          word.removeAttribute('style');
        }
      });

      if (this.wordsContainer && maxWidth > 0) {
        const currentWidth = this.wordsContainer.getBoundingClientRect().width;
        if (Math.abs(currentWidth - maxWidth) <= 2) {
          return;
        }
        this.wordsContainer.style.width = `${maxWidth}px`;
      }
    }

    rotateWords() {
      const currentItem = this.words[this.currentIndex];
      const nextIndex = (this.currentIndex + 1) % this.wordCount;
      const nextItem = this.words[nextIndex];

      currentItem.classList.add('fade-out');
      currentItem.classList.remove('active');

      setTimeout(() => {
        currentItem.classList.remove('fade-out');
        nextItem.classList.add('active');
        this.currentIndex = nextIndex;
      }, this.transitionSpeed);
    }
  }

  customElements.define('rotating-header-unique', RotatingHeader);
}
